var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7487 5.74308L8.61769 9.68114C8.26561 10.0202 7.70229 9.7333 7.70229 9.2117V6.94275C4.04067 6.99491 2.49153 7.98595 3.54776 11.7675C3.66512 12.1848 3.19568 12.5238 2.89055 12.263C1.85779 11.4285 0.942383 9.83762 0.942383 8.24675C0.942383 4.28261 3.92331 3.42197 7.70229 3.36981V1.3095C7.70229 0.761823 8.26561 0.474945 8.61769 0.813983L12.7487 4.75204C13.0069 5.03892 13.0069 5.48228 12.7487 5.74308Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.e3385c8247806cce28e433e36f4ce09a.svg";
export { ForwardRef as ReactComponent };